import styled from 'styled-components';

const RepeatingGridColumns = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(${props => `min(${props.columnWidth ?? '20rem'}, 100%)`}, 1fr));
`;

export default RepeatingGridColumns;